import React, { useRef } from "react";
import NotificationMark from "../NotificationMark";
import styles from "./MyPageSideBar.module.scss";
import { useMypagePrefetch } from "../../../utils/usePrefetch";
import SonicLink from "../../../common/routing/SonicLink";

type Props = {
  link: string;
  title: string;
  icon: any;
  showNotification?: boolean;
};

const MyPageSideBarItem: React.FC<Props> = ({
  link,
  title,
  icon,
  showNotification = false,
}) => {
  const ref = useRef<boolean>();
  const prefetch = useMypagePrefetch(link);

  return (
    <li
      className={styles["g-mypagesidebar__nav-item"]}
      onMouseEnter={() => {
        if (!ref.current) {
          prefetch();
          ref.current = true;
        }
      }}
    >
      <SonicLink to={link} className={styles["g-mypagesidebar__nav-link"]}>
        <div className={styles["g-mypagesidebar__nav-icon"]}>{icon}</div>
        <div className={styles["g-mypagesidebar__nav-text"]}>{title}</div>
        {showNotification && <NotificationMark />}
      </SonicLink>
    </li>
  );
};

export default MyPageSideBarItem;
